import { Pagination } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { PropsTableFooter } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";

import * as styles from "./TableFooter.module.less";
/**
 * Компонент футера таблицы
 */
export const TableFooter = observer((props: PropsTableFooter) => {
  const { store, showTotal, showSizeChanger = false } = props;

  // Если нет данных для пагинации, не показываем футер
  if (!store.totalRows || !store.pageSize) {
    return null;
  }

  return (
    <div className={styles.box}>
      <Pagination
        current={store.page + 1}
        pageSize={store.pageSize}
        total={store.totalRows}
        onChange={(page, pageSize) => {
          store.setPageSize(pageSize);
          store.setPage(page - 1);
        }}
        showTotal={showTotal}
        showSizeChanger={showSizeChanger}
      />
    </div>
  );
});
